import { render, staticRenderFns } from "./coreEdit.vue?vue&type=template&id=38b53602"
import script from "./coreEdit.vue?vue&type=script&lang=js"
export * from "./coreEdit.vue?vue&type=script&lang=js"
import style0 from "./coreEdit.vue?vue&type=style&index=0&id=38b53602&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports